var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onCancel,
          expression: "onCancel"
        }
      ]
    },
    [
      _c("div", { on: { click: _vm.open } }, [
        _vm.cropLoading
          ? _c("img", {
              ref: "previewImage",
              staticClass: "img-thumbnail",
              attrs: {
                width: "100px",
                height: "auto",
                src:
                  _vm.options.imageToCropPreview +
                  "?" +
                  Math.floor(Math.random() * 100000)
              }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.cropLoading
          ? _c("img", {
              ref: "previewImage",
              staticClass: "img-thumbnail",
              attrs: {
                width: "100px",
                height: "auto",
                src:
                  _vm.options.imageToCropPreview +
                  "?" +
                  Math.floor(Math.random() * 100000)
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.show
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modal-mask centered-modal" }, [
                  _c("div", { staticClass: "modal-wrapper" }, [
                    _c("div", { staticClass: "modal-dialog" }, [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button" },
                              on: { click: _vm.onCancel }
                            },
                            [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "modal-title" }, [
                            _vm._v("Resim")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-body" }, [
                          _c(
                            "div",
                            { staticClass: "cropper-area" },
                            [
                              _c("vue-cropper", {
                                ref: "cropper",
                                attrs: {
                                  src: _vm.options.imageToCropPreview,
                                  zoomable: false,
                                  aspectRatio: _vm.options.aspectRatio,
                                  autoCrop: true,
                                  autoCropArea: 0.99,
                                  cropmove: _vm.move,
                                  ready: _vm.ready,
                                  checkCrossOrigin: false,
                                  checkOrientation: false,
                                  viewMode: 1
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("footer", [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.cropLoading,
                                  expression: "!cropLoading"
                                }
                              ]
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  on: { click: _vm.onCancel }
                                },
                                [_vm._v("Cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                { staticClass: "btn", on: { click: _vm.crop } },
                                [_vm._v("Crop")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.cropLoading,
                                  expression: "cropLoading"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                "\n                                    Kesiliyor...\n                                "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-458ca06c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-458ca06c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/vue/image-cropper.vue
// module id = 81
// module chunks = 0